export const isFeatureEnabled = (key) => {
  return process.env[`REACT_APP_FLAG_${key}`] === 'true';
};